import { render, staticRenderFns } from "./VerkaufVerteilungView.vue?vue&type=template&id=3f7e0c5e&"
import script from "./VerkaufVerteilungView.vue?vue&type=script&lang=js&"
export * from "./VerkaufVerteilungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports